/* eslint-disable @typescript-eslint/no-explicit-any */
import { FieldRow } from "@/types/workflowHistory";

export const getInputOutputForStep = (data: unknown): string => {
  if (
    data === undefined ||
    data === null ||
    (typeof data === 'string' && data.trim() === '') ||
    (typeof data === 'object' && Object.keys(data).length === 0)
  ) {
    return 'N/A';
  }

  try {
    const parsed = typeof data === 'string' ? JSON.parse(data) : data;
    return JSON.stringify(parsed, null, 2); // formatted JSON string
  } catch (e) {
    return 'Invalid JSON';
  }
};

export const isValidFieldsData = (data: unknown): data is FieldRow[] => {
  if (!Array.isArray(data)) return false
  return data.every((item) =>
    typeof item === "object" &&
    item !== null &&
    "identifier" in item &&
    "fields" in item &&
    Array.isArray((item as any)?.fields) &&
    (item as any).fields.every((f: any) =>
      f &&
      typeof f?.codeChain === "string" &&
      "value" in f &&
      typeof f?.value === 'string' || typeof f?.value === 'number' || typeof f?.value === 'boolean'
    )
  )
}

export const transformInputOutputToTableFriendlyRows = (data: FieldRow[]) => {
  return data.map((item) => {
    const flat: Record<string, string> = {}
    item.fields.forEach((f) => {
      if (f.value === null || f.value === undefined) {
        flat[f.codeChain] = "";
      } else {
        flat[f.codeChain] = String(f.value);
      }
    })
    return flat
  })
}
